export default __webpack_public_path__ + "static/bruce-cf60aadf0a1641e164b2f3be37c601aa.jpeg";